/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_Meal_LogInputs */

const en_for_whom_tag_meal_log = /** @type {(inputs: For_Whom_Tag_Meal_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal log`)
};

const pl_for_whom_tag_meal_log = /** @type {(inputs: For_Whom_Tag_Meal_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik posiłków`)
};

/**
* | output |
* | --- |
* | "Meal log" |
*
* @param {For_Whom_Tag_Meal_LogInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_meal_log = /** @type {((inputs?: For_Whom_Tag_Meal_LogInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_Meal_LogInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_meal_log(inputs)
	return en_for_whom_tag_meal_log(inputs)
});